// extracted by mini-css-extract-plugin
export default {"container":"SendEmail_container__1gvAx","formGroup":"SendEmail_formGroup__+yYD9","actions":"SendEmail_actions__KckRj"};